var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "schoolNameArea", class: { isPc: !_vm.isSp } },
      [
        _c(
          "InputLabel",
          {
            staticClass: "labelArea",
            class: {
              isPc: !_vm.isSp,
              isHasLabel: !_vm.isSp && (_vm.required || _vm.optional),
              isPcModal: _vm.isPcModal,
            },
            attrs: {
              required: _vm.required,
              optional: _vm.optional,
              "is-pc-modal": _vm.isPcModal,
            },
          },
          [_vm._v("\n      学校名\n    ")]
        ),
        _vm._v(" "),
        _c("InputItem", {
          staticClass: "inputItem",
          class: {
            hasError: _vm.hasError,
            isPc: !_vm.isSp,
            isPcModal: _vm.isPcModal,
          },
          attrs: {
            "input-type": "text",
            "placeholder-value": "高校名を入力すると選択肢が表示されます",
            disabled: _vm.disabled,
            "is-pc-modal": _vm.isPcModal,
            "input-mode": "",
          },
          on: { input: _vm.onInput, blur: _vm.onBlur, focus: _vm.onFocus },
          model: {
            value: _vm.handleInputValue,
            callback: function ($$v) {
              _vm.handleInputValue = $$v
            },
            expression: "handleInputValue",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "underInputArea",
        class: { isPc: !_vm.isSp, isPcModal: _vm.isPcModal },
      },
      [
        _c("SuggestList", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isDisplaySuggest && _vm.arrangedSuggestList.length > 1,
              expression: "isDisplaySuggest && arrangedSuggestList.length > 1",
            },
          ],
          staticClass: "suggestArea",
          class: { isPc: !_vm.isSp },
          attrs: { list: _vm.arrangedSuggestList },
          on: { onClick: _vm.onClick },
        }),
        _vm._v(" "),
        _c("PartialErrorMessage", {
          staticClass: "partialErrorComponent",
          attrs: { "is-sp-flg": true, error: _vm.displayError },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }